import { render } from "./textInputModal.vue?vue&type=template&id=898a238e&ts=true"
import script from "./textInputModal.vue?vue&type=script&lang=ts"
export * from "./textInputModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__